import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponsService_GetCoupons} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/wallet/service.grpc';
import {useSelectedDiscountRequestParameter} from '../../../../backend-services/Campaigns/SelectedDiscounts/useSelectedDiscount';
import {useFullSession} from '@aboutyou/user';

export const useGetCoupons = ({isDisabled}: {isDisabled?: boolean}) => {
  const fullSession = useFullSession();

  return useGrpcRequest(
    CouponsService_GetCoupons,
    {
      selectedDiscount: useSelectedDiscountRequestParameter(),
      session: fullSession!,
    },
    {
      disabled: !fullSession || isDisabled,
    },
  );
};
